export const normalizeEventEmail = (o?: string) => {
	return o ? o.toLowerCase() : o
}
